import { render, staticRenderFns } from "./HistoryFooTable.vue?vue&type=template&id=4a53b83e&scoped=true"
import script from "./HistoryFooTable.vue?vue&type=script&lang=js"
export * from "./HistoryFooTable.vue?vue&type=script&lang=js"
import style0 from "./HistoryFooTable.vue?vue&type=style&index=0&id=4a53b83e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a53b83e",
  null
  
)

export default component.exports